import React from 'react';
import {
  EditDisclaimerWrapper,
  AlertIcon,
  Disclaimer,
  DisclaimerText,
  Link
} from './EditDisclaimer.styles';
import { KissMetrics } from '../../services';

const EditDisclaimer = () => (
  <EditDisclaimerWrapper>
    <AlertIcon />
    <Disclaimer>
      <DisclaimerText>
        <strong>WARNING: </strong>
        Editing your information below will not update your current purchase.
      </DisclaimerText>
      <DisclaimerText>
        If you need to make changes to your purchase, please{' '}
        <Link
          href="/acquisition/order-placed-dashboard"
          onClick={() =>
            KissMetrics.trackEvent(
              'Account - Personal Details - Clicked Click Here - Order Placed Dashboard Redirect'
            )
          }
        >
          click here
        </Link>{' '}
        for next steps.
      </DisclaimerText>
    </Disclaimer>
  </EditDisclaimerWrapper>
);

export default EditDisclaimer;
